import React from "react";
import { useDispatch } from "react-redux";
import { updateShowOverwriteStructureWarningModal } from "@src/reducers/your-reducer";
import CloseIcon from "@src/assets/svg/close-icon.svg";
import { Title } from "@components/atoms/title/title";
import styles from "./overwrite-structure-warning-modal.module.scss";
import { HintTitle } from "@components/atoms/hint-title/hint-title";
import { Button } from "@components/atoms/buttons/button/button";
import { GlassyModal } from "../glassy-modal/glassy-modal";
import { GlassyModalHeader } from "@src/components/molecules/glassy-modal-header/glassy-modal-header";
import { HorizontalSeparator } from "@src/components/atoms/horizontal-separator/horizontal-separator";
import { Spacer16 } from "@src/components/atoms/spacer-16/spacer-16";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { transferInitialListToEmptyOurNodeMachineStructure } from "../../tree-structure/tree-components/tree-our-node/use-cases/transfer-initial-list-to-empty-our-node-machine-structure";
import { useI18N } from "@src/language/language-context";

const cssClassName = "overwrite-structure-warning-modal";

export const OverwriteStructureWarningModal = () => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const texts = {
    subTitle: i18n("modules.overwriteStructureWarningModal.subTitle"),
    title: i18n("modules.overwriteStructureWarningModal.title"),
    description: i18n("modules.overwriteStructureWarningModal.description"),
    transferButton: i18n(
      "modules.overwriteStructureWarningModal.transferButton",
    ),
    abortButton: i18n("modules.overwriteStructureWarningModal.abortButton"),
  };

  const closeModal = () => {
    dispatch(updateShowOverwriteStructureWarningModal(false));
  };

  const closeModalWithoutTransfering = () => {
    closeModal();
  };

  const transferNodeAndCloseModal = () => {
    transferInitialListToEmptyOurNodeMachineStructure();

    closeModal();
  };

  return (
    <GlassyModal>
      <div className={styles[cssClassName]}>
        <GlassyModalHeader
          title={texts.subTitle}
          rightIcon={CloseIcon}
          rightIconFunction={closeModal}
        />
        <HorizontalSeparator verticalMargin={16} />
        <Spacer16 />
        <div className={styles[`${cssClassName}__modal-content`]}>
          <Title text={texts.title} />
          <div className={styles[`${cssClassName}__hint-content`]}>
            <HintTitle text={texts.description} />
          </div>
          <FlexRowContainer justifyContent="center">
            <Button
              fun={transferNodeAndCloseModal}
              text={texts.transferButton}
            />
            <Button
              variant={["secondary", "alert"]}
              fun={closeModalWithoutTransfering}
              text={texts.abortButton}
            />
          </FlexRowContainer>
        </div>
      </div>
    </GlassyModal>
  );
};
